type Props = {
  children: React.ReactNode;
};

export default function Apm({ children }: Props) {
  return <>{children}</>;
}
